import axios from "axios"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { BASE_URL, BRANCHES_API } from "../../../Utilities/APIs"
import Modal from "../../Partials/Elements/Modal/Modal"
import CreateButton from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDDashboardBoilerplate/CRUDHeader/CreateButton/CreateButton"
import CRUDDeleteBoilerPlate from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDDeleteBoilerPlate/CRUDDeleteBoilerPlate"
import DeleteButton from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/DeleteButton/DeleteButton"
import EditButton from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/EditButton/EditButton"
import ViewButton from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/ViewButton/ViewButton"
import CRUDTable from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTable"
import ImageCell from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableCells/ImageCell/ImageCell"
import ShortTextCell from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell"
import CRUDTableHeader from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDTableHeader"
import CRUDth from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDth/CRUDth"
import CRUDTableRow from "../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableRow/CRUDTableRow"
import CreateBranch from "./BranchCRUDs/CreateBranch"
import UpdateBranch from "./BranchCRUDs/UpdateBranch"
import ViewBranch from "./BranchCRUDs/ViewBranch"

function Branches() {

    const [branches, setBranches] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const [targetID, setTargetID] = useState(null)
    const [showViewSection, setShowViewSection] = useState(false)
    const [showCreateForm, setShowCreateForm] = useState(false)
    const [showUpdateForm, setShowUpdateForm] = useState(false)
    const [showDeleteSection, setShowDeleteSection] = useState(false)
    const [toggleFetch, setToggleFetch] = useState(false)

    const {employee} = useSelector(state => state.auth)

    const {organizationID} = useParams()

    useEffect(() => {

        async function fetchAndSetBranches() {
            const {data} = await axios.get(BRANCHES_API + 'getBranchesOfSingleOrganization/' + organizationID)
            setBranches(data)
        }

        fetchAndSetBranches()

    }, [toggleFetch, organizationID])

    function handleClose() {
        setShowModal(false);
        setShowCreateForm(false);
        setShowViewSection(false);
        setShowUpdateForm(false);
        setShowDeleteSection(false);
    }

    function triggerFetch() {
        setToggleFetch(prevState => !prevState)
    }
    
    return (
        <>
            <div>
                <div className="body_header">
                    <h1 className="heading">{`Branches (${branches?.length} in total)`}</h1>
                    <CreateButton
                        screenTopicSingular='Branch'
                        setShowModal={setShowModal}
                        setShowCreateForm={setShowCreateForm}
                    />
                </div>
                <CRUDTable>
                    <CRUDTableHeader>
                        <CRUDth th= 'Branch Name' />
                        <CRUDth th= 'Phone Number' />
                        <CRUDth th= 'Branch Image' />
                        <CRUDth th= 'Actions' />
                    </CRUDTableHeader>
                    <tbody>
                        {branches?.map(branch => (
                            <CRUDTableRow key={branch._id}>
                                <ShortTextCell text={branch.name} />
                                <ShortTextCell text={branch.branchPhoneNumber} />
                                <ImageCell imgSrc={BASE_URL + branch.image.slice(6, branch.image.length)} alt={branch.name} />
                                
                                <td className="action_button_cell">
                                    <ViewButton
                                    setShowModal={setShowModal}
                                    setShowViewSection={setShowViewSection}
                                    targetID={branch._id}
                                    setTargetID={setTargetID}
                                    />
                                    <EditButton
                                        setShowModal={setShowModal}
                                        setShowUpdateForm={setShowUpdateForm}
                                        targetID={branch._id}
                                        setTargetID={setTargetID}
                                    />
                                    
                                    <DeleteButton
                                        setShowModal={setShowModal}
                                        setShowDeleteSection={setShowDeleteSection}
                                        targetID={branch._id}
                                        setTargetID={setTargetID}
                                    />
                                </td>
                            </CRUDTableRow>
                        ))}
                    </tbody>
                </CRUDTable>
            </div>
            {showModal && 
                <Modal
                    handleClose={handleClose}
                    modalHeading={
                        (showViewSection && `View Branch`) || 
                        (showCreateForm && `Create Branch`) || 
                        (showUpdateForm && `Update Branch`) || 
                        (showDeleteSection && `Delete Branch`)
                    }
                >
                    {
                        showViewSection &&
                            <ViewBranch
                                targetID={targetID}
                                employee={employee}
                            />
                    }    
                    {
                        showCreateForm &&
                            <CreateBranch
                                employee={employee}
                                setShowCreateForm={setShowCreateForm}
                                setShowModal={setShowModal}
                                triggerFetch={triggerFetch}
                                organizationID={organizationID}
                            />
                    }    
                    {
                        showUpdateForm &&
                            <UpdateBranch
                                employee={employee}
                                targetID={targetID}
                                setShowUpdateForm={setShowUpdateForm}
                                setShowModal={setShowModal}
                                triggerFetch={triggerFetch}
                                organizationID={organizationID}
                            />
                    }
                    {
                        showDeleteSection &&
                            <CRUDDeleteBoilerPlate
                                api={BRANCHES_API}
                                targetID={targetID}
                                employee={employee}
                                setShowModal={setShowModal}
                                setShowDeleteSection={setShowDeleteSection}
                                hasName
                                triggerFetch={triggerFetch}
                            />
                    }    
                </Modal>
            }
        </>
    )
}

export default Branches